import { FC } from 'react';

import { IconName } from '@purpur/library/icon';

import { getSvgIcon } from '@telialt/common-icon/src/utils';

import { DualMode, IconModeDesktop, IconModeMobile } from './AdaptiveIcon.styles';

export const AdaptiveIcon: FC<{ icon: IconName; className?: string }> = ({ icon, className }) => {
    const svg = getSvgIcon(icon);

    return (
        <DualMode className={className}>
            <IconModeDesktop svg={svg} />
            <IconModeMobile svg={svg} />
        </DualMode>
    );
};
